// import React, { useEffect } from 'react'
// import { useDispatch, useSelector } from 'react-redux';
// import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, TextField, useMediaQuery } from '@mui/material';
// import { useTheme } from '@emotion/react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { useLocation, useNavigate } from 'react-router-dom';
// import Header from '../../../components/Header';
// import { addAssignInstaller, editAssignInstaller, getAssignInstaller, getassignuser } from '../../../redux/slice/assigninstaller.slice';

// const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
//     [`&.${stepConnectorClasses.alternativeLabel}`]: {
//         top: 22,
//     },
//     [`&.${stepConnectorClasses.active}`]: {
//         [`& .${stepConnectorClasses.line}`]: {
//             backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
//         },
//     },
//     [`&.${stepConnectorClasses.completed}`]: {
//         [`& .${stepConnectorClasses.line}`]: {
//             backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
//         },
//     },
//     [`& .${stepConnectorClasses.line}`]: {
//         height: 3,
//         border: 0,
//         backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
//         borderRadius: 1,
//     },
// }));

// function ColorlibStepIcon(props) {
//     const { active, completed, className, icon, onClick, theme, error } = props;
//     const icons = {
//         1: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
//         2: <img src="/assets/images/icons/Customer.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
//         3: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
//     };

//     return (
//         <ColorlibStepIconRoot ownerState={{ completed, active, error }} className={className} onClick={onClick}>
//             {icons[String(icon)]}
//         </ColorlibStepIconRoot>
//     );
// }
// const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
//     backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
//     zIndex: 1,
//     color: '#fff',
//     width: 50,
//     height: 50,
//     display: 'flex',
//     borderRadius: '50%',
//     justifyContent: 'center',
//     alignItems: 'center',
//     ...(ownerState.active && {
//         border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
//         boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
//     }),
//     ...(ownerState.completed && {
//         border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
//     }),
//     ...(ownerState.error && {
//         border: '2px solid red',
//     }),
// }));


// function AddAssignInstaller() {

//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { state } = useLocation();
//     const liasoningId = state?.LiasoningId;
//     const fabStatus = state?.fabStatus;
//     const elecStatus = state?.elecStatus
//     const id = state?.assignId;
//     const AllAssignInstaller = useSelector(state => state.assignInstaller.assignInstaller).find(assign => assign.liasoningId == liasoningId);
//     const isNonMobile = useMediaQuery("(min-width:600px)");
//     const theme = useTheme();

//     const Fabricatorusers = useSelector(state => state.assignInstaller.assignuser.filter(user => user.roleData[0]?.permissions.includes("Installer")))
//     const Electricianusers = useSelector(state => state.assignInstaller.assignuser.filter(user => user.roleData[0]?.permissions.includes("Installer")))
    

//     const [activeStep, setActiveStep] = React.useState(0);
//     const [stepsWithErrors, setStepsWithErrors] = React.useState([false, false, false, false, false]);
//     const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);

//     useEffect(() => {
//         dispatch(getassignuser())
//     }, [dispatch])
//     const isMobile = useMediaQuery('(max-width:500px)');


//     const isSmallScreen = useMediaQuery("(max-width:425px)");
//     const steps = ['Fabricator', 'Electrician'];

//     const validationSchemas =
//         Yup.object({});

//     const initialValues = {
//         liasoningId: liasoningId,
//         FabricatorDate: '',
//         Fabricator: '',
//         ElectricianDate: '',
//         Electrician: '',
//     };


//     const handleSubmit = (values) => {
//         validationSchemas.validate(values, { abortEarly: false })
//             .then(() => {
//                 const submissionValues = {
//                     ...values,
//                     liasoningId: liasoningId,
//                     Fabricator: values.Fabricator || null,
//                     Electrician: values.Electrician || null,
//                 };
//                 if (id) {
//                     dispatch(editAssignInstaller({ id: id, ...submissionValues }));
//                 } else {
//                     dispatch(addAssignInstaller(submissionValues));
//                 }
//                 setActiveStep(0);
//                 navigate('/admin/assign-to-installer');
//             })
//             .catch((validationErrors) => {
//                 console.log("Form validation errors:", errors);
//                 alert("Please fill in all required fields before submitting.");
//             });
//     };

//     const { handleBlur, handleChange, values, touched, errors, setFieldValue, setValues, validateForm, setFieldError, setFieldTouched } = useFormik({
//         initialValues: { ...initialValues, },
//         validationSchema: validationSchemas,
//         onSubmit: handleSubmit,
//     });


//     const handleBack = () => {
//         setActiveStep((prevActiveStep) => prevActiveStep - 1);
//     };
//     const handleStep = (step) => {
//         setActiveStep(step);
//     };

//     React.useEffect(() => {
//         if (touchedSteps.some(touched => touched)) {
//             validateForm().then((formErrors) => {
//                 const newStepsWithErrors = [false, false, false];

//                 Object.keys(formErrors).forEach((errorKey) => {
//                     steps.forEach((_, stepIndex) => {
//                         if (errorBelongsToStep(errorKey, stepIndex)) {
//                             newStepsWithErrors[stepIndex] = true;
//                         }
//                     });
//                 });

//                 setStepsWithErrors(newStepsWithErrors);
//             });
//         }
//     }, [values, touchedSteps]);


//     const errorBelongsToStep = (errorKey, stepIndex) => {
//         if (stepIndex === 0) {
//             return ['FabricatorDate', 'Fabricator'].includes(errorKey);
//         }
//         else if (stepIndex === 1) {
//             return ['ElectricianDate', 'Electrician'].includes(errorKey);
//         }
        
//     };

//     useEffect(() => {
//         if (liasoningId) {
//             dispatch(getAssignInstaller());
//         }
//     }, [liasoningId, id]);

//     useEffect(() => {
//         if (id && AllAssignInstaller) {
//             setValues(AllAssignInstaller);
//         }
//     }, [id, AllAssignInstaller]);


//     return (
//         <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
//             {id ? (
//                 <Header
//                     title="UPDATE ASSIGN INSTALLER"
//                     subtitle="Update Your Assign Installer Detail"
//                 />
//             ) : (
//                 <Header
//                     title="ADD ASSIGN INSTALLER"
//                     subtitle="Manage Your Assign Installer Detail"
//                 />
//             )}
//             <form onSubmit={handleSubmit} >
//                 <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
//                     {isSmallScreen ? (
//                         <>
//                             <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
//                                 {steps.slice(0, 3).map((label, index) => (
//                                     <Step key={label}>
//                                         <StepLabel StepIconComponent={(props) => (
//                                             <ColorlibStepIcon
//                                                 {...props}
//                                                 theme={theme}
//                                                 icon={index + 1}
//                                                 onClick={() => handleStep(index)}
//                                                 error={touchedSteps[index] && stepsWithErrors[index]}
//                                             />
//                                         )}>
//                                             {label}
//                                         </StepLabel>
//                                     </Step>
//                                 ))}
//                             </Stepper>
//                             <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
//                                 {steps.slice(3).map((label, index) => (
//                                     <Step key={label}>
//                                         <StepLabel StepIconComponent={(props) => (
//                                             <ColorlibStepIcon
//                                                 {...props}
//                                                 theme={theme}
//                                                 icon={index + 4}
//                                                 onClick={() => handleStep(index + 3)}
//                                                 error={touchedSteps[index + 3] && stepsWithErrors[index + 3]}
//                                             />
//                                         )}>
//                                             {label}
//                                         </StepLabel>
//                                     </Step>
//                                 ))}
//                             </Stepper>
//                         </>
//                     ) : (
//                         <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
//                             {steps.map((label, index) => (
//                                 <Step key={label}>
//                                     <StepLabel StepIconComponent={(props) => (
//                                         <ColorlibStepIcon
//                                             {...props}
//                                             theme={theme}
//                                             icon={index + 1}
//                                             onClick={() => handleStep(index)}
//                                             error={touchedSteps[index] && stepsWithErrors[index]}
//                                         />
//                                     )}>
//                                         {label}
//                                     </StepLabel>
//                                 </Step>
//                             ))}
//                         </Stepper>
//                     )}
//                     {activeStep === 0 && (
//                         <>
//                             <Box
//                                 display="grid"
//                                 gap="30px"
//                                 gridTemplateColumns="repeat(3, minmax(0, 1fr))"
//                                 sx={{
//                                     "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
//                                 }}
//                             >
//                                 <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
//                                     <TextField
//                                         fullWidth
//                                         variant="filled"
//                                         type="date"
//                                         label="Date:"
//                                         onBlur={handleBlur}
//                                         onChange={handleChange}
//                                         value={values.FabricatorDate}
//                                         name="FabricatorDate"
//                                         error={!!touched.FabricatorDate && !!errors.FabricatorDate}
//                                         helperText={touched.FabricatorDate && errors.FabricatorDate}
//                                         sx={{ gridColumn: "span 2" }}
//                                         InputLabelProps={{
//                                             shrink: true,
//                                             style: {
//                                                 color: theme.palette.text.primary
//                                             }
//                                         }}
//                                     />
//                                 </FormControl>
//                                 <FormControl variant="filled" sx={{ mx: 1, mt: 1, minWidth: 120 }}>
//                                     <InputLabel id="Fabricator-label">Select Fabricator:</InputLabel>
//                                     <Select
//                                         labelId="Fabricator-label"
//                                         id="Fabricator"
//                                         name="Fabricator"
//                                         value={values.Fabricator}
//                                         onChange={handleChange}
//                                         onBlur={handleBlur}
//                                         error={touched.Fabricator && Boolean(errors.Fabricator)}
//                                         sx={{
//                                             gridColumn: "span 2",
//                                             color: theme.palette.text.primary
//                                         }}
//                                     >
//                                         {Fabricatorusers.map((user) => (
//                                             <MenuItem key={user._id} value={user._id}>
//                                                 {user.name}
//                                             </MenuItem>
//                                         ))}
//                                     </Select>
//                                     {touched.Fabricator && errors.Fabricator && (
//                                         <FormHelperText error>{errors.Fabricator}</FormHelperText>
//                                     )}
//                                 </FormControl>
//                             </Box>

//                         </>
//                     )}
//                     {activeStep === 1 && (
//                         <>

//                             <Box
//                                 display="grid"
//                                 gap="30px"
//                                 gridTemplateColumns="repeat(3, minmax(0, 1fr))"
//                                 sx={{
//                                     "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
//                                 }}
//                             >
//                                 <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
//                                     <TextField
//                                         fullWidth
//                                         variant="filled"
//                                         type="date"
//                                         label="Date:"
//                                         onBlur={handleBlur}
//                                         onChange={handleChange}
//                                         value={values.ElectricianDate}
//                                         name="ElectricianDate"
//                                         error={!!touched.ElectricianDate && !!errors.ElectricianDate}
//                                         helperText={touched.ElectricianDate && errors.ElectricianDate}
//                                         sx={{ gridColumn: "span 2" }}
//                                         InputLabelProps={{
//                                             shrink: true,
//                                             style: {
//                                                 color: theme.palette.text.primary
//                                             }
//                                         }}
//                                     />
//                                 </FormControl>
//                                 <FormControl variant="filled" sx={{ mx: 1, mt: 1, minWidth: 120 }}>
//                                     <InputLabel id="Electrician-label">Select Electrician:</InputLabel>
//                                     <Select
//                                         labelId="Electrician-label"
//                                         id="Electrician"
//                                         name="Electrician"
//                                         value={values.Electrician}
//                                         onChange={handleChange}
//                                         onBlur={handleBlur}
//                                         error={touched.Electrician && Boolean(errors.Electrician)}
//                                         sx={{
//                                             gridColumn: "span 2",
//                                             color: theme.palette.text.primary
//                                         }}
//                                     >
//                                         {Electricianusers.map((user) => (
//                                             <MenuItem key={user._id} value={user._id}>
//                                                 {user.name}
//                                             </MenuItem>
//                                         ))}
//                                     </Select>
//                                     {touched.Electrician && errors.Electrician && (
//                                         <FormHelperText error>{errors.Electrician}</FormHelperText>
//                                     )}
//                                 </FormControl>
//                             </Box>
//                         </>
//                     )}

                   

//                     <FormControl>
//                         <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
//                             <Button
//                                 variant="contained"
//                                 disabled={activeStep === 0}
//                                 onClick={handleBack}
//                             >
//                                 Back
//                             </Button>
//                             {activeStep < 1 && (
//                                 <Button
//                                     variant="contained"
//                                     color="primary"
//                                     onClick={() => setActiveStep((prev) => prev + 1)}
//                                 >
//                                     Next
//                                 </Button>
//                             )}
//                             <Button
//                                 variant="contained"
//                                 color="primary"
//                                 type="button"
//                                 onClick={() => handleSubmit(values)}
//                             >
//                                 {id ? 'Update' : 'save'}
//                             </Button>
//                         </Stack>
//                     </FormControl>
//                 </Stack>
//             </form>
//         </Box>
//     )
// }

// export default AddAssignInstaller


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, TextField, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import { addAssignInstaller, editAssignInstaller, getAssignInstaller, getassignuser } from '../../../redux/slice/assigninstaller.slice';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, theme, error } = props;
    const icons = {
        1: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        2: <img src="/assets/images/icons/Customer.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        3: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active, error }} className={className} onClick={onClick}>
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}
const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
    ...(ownerState.error && {
        border: '2px solid red',
    }),
}));


function AddAssignInstaller() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const liasoningId = state?.LiasoningId;
    const fabStatus = state?.fabStatus;
    const elecStatus = state?.elecStatus;
    const id = state?.assignId;
    const AllAssignInstaller = useSelector(state => state.assignInstaller.assignInstaller).find(assign => assign.liasoningId == liasoningId);
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const theme = useTheme();

    const Fabricatorusers = useSelector(state => state.assignInstaller.assignuser.filter(user => user.roleData[0]?.permissions.includes("Installer")));
    const Electricianusers = useSelector(state => state.assignInstaller.assignuser.filter(user => user.roleData[0]?.permissions.includes("Installer")));
    
    const [activeStep, setActiveStep] = React.useState(0);
    const [stepsWithErrors, setStepsWithErrors] = React.useState([false, false]); // Only 2 steps now
    const [touchedSteps, setTouchedSteps] = React.useState([false, false]); // Only 2 steps now

    useEffect(() => {
        dispatch(getassignuser());
    }, [dispatch]);

    const isMobile = useMediaQuery('(max-width:500px)');
    const isSmallScreen = useMediaQuery("(max-width:425px)");
    const steps = ['Fabricator', 'Electrician'];

    // Define validation schemas for each step separately
    const validationSchemas = {
        0: Yup.object().shape({
            FabricatorDate: Yup.date().required('Fabricator Date is required'),
            Fabricator: Yup.string().required('Fabricator is required'),
        }),
        1: Yup.object().shape({
            ElectricianDate: Yup.date().required('Electrician Date is required'),
            Electrician: Yup.string().required('Electrician is required'),
        }),
    };

    const initialValues = {
        liasoningId: liasoningId,
        FabricatorDate: '',
        Fabricator: '',
        ElectricianDate: '',
        Electrician: '',
    };

    const formik = useFormik({
        initialValues: { ...initialValues },
        // We'll validate manually per step
        onSubmit: (values) => {
            const submissionValues = {
                ...values,
                liasoningId: liasoningId,
                Fabricator: values.Fabricator || null,
                Electrician: values.Electrician || null,
            };

            // Only submit if the current active step's status allows it
            if (activeStep === 0 && fabStatus === 'complete') {
                alert("Fabricator assignment is already complete. Cannot save.");
                return;
            }
            if (activeStep === 1 && elecStatus === 'complete') {
                alert("Electrician assignment is already complete. Cannot save.");
                return;
            }

            // Perform validation for the current active step
            const currentStepSchema = validationSchemas[activeStep];
            currentStepSchema.validate(values, { abortEarly: false })
                .then(() => {
                    if (id) {
                        dispatch(editAssignInstaller({ id: id, ...submissionValues }));
                    } else {
                        dispatch(addAssignInstaller(submissionValues));
                    }
                    setActiveStep(0); // Reset step after successful submission
                    navigate('/admin/assign-to-installer');
                })
                .catch((validationErrors) => {
                    console.log("Form validation errors:", validationErrors.errors);
                    // Set errors for the current step
                    validationErrors.inner.forEach(error => {
                        formik.setFieldError(error.path, error.message);
                        formik.setFieldTouched(error.path, true);
                    });
                    alert("Please fill in all required fields for the current step.");
                });
        },
    });

    const { handleBlur, handleChange, values, touched, errors, setValues, setFieldError, setFieldTouched } = formik;

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = () => {
        // Validate current step before proceeding to next
        const currentStepSchema = validationSchemas[activeStep];
        currentStepSchema.validate(values, { abortEarly: false })
            .then(() => {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                // Mark current step as touched to show errors on step icon if validation fails
                setTouchedSteps(prev => {
                    const newTouched = [...prev];
                    newTouched[activeStep] = true;
                    return newTouched;
                });
            })
            .catch((validationErrors) => {
                console.log("Form validation errors for next step:", validationErrors.errors);
                validationErrors.inner.forEach(error => {
                    formik.setFieldError(error.path, error.message);
                    formik.setFieldTouched(error.path, true);
                });
                // Mark current step with an error
                setStepsWithErrors(prev => {
                    const newErrors = [...prev];
                    newErrors[activeStep] = true;
                    return newErrors;
                });
                alert("Please fill in all required fields for the current step before proceeding.");
            });
    };

    const handleStep = (step) => {
        // Allow stepping back freely
        if (step < activeStep) {
            setActiveStep(step);
            return;
        }

        // Validate previous steps if jumping forward
        let canProceed = true;
        for (let i = 0; i < step; i++) {
            const stepSchema = validationSchemas[i];
            try {
                stepSchema.validateSync(values);
                setStepsWithErrors(prev => {
                    const newErrors = [...prev];
                    newErrors[i] = false; // Clear error if valid
                    return newErrors;
                });
            } catch (error) {
                setStepsWithErrors(prev => {
                    const newErrors = [...prev];
                    newErrors[i] = true; // Set error if invalid
                    return newErrors;
                });
                canProceed = false;
                break;
            }
        }

        if (canProceed) {
            setActiveStep(step);
        } else {
            alert("Please complete the previous steps before jumping forward.");
        }
    };

    useEffect(() => {
        if (liasoningId) {
            dispatch(getAssignInstaller());
        }
    }, [liasoningId, id, dispatch]);

    useEffect(() => {
        if (id && AllAssignInstaller) {
            setValues(AllAssignInstaller);
        }
    }, [id, AllAssignInstaller, setValues]);

    // Determine if the save/update button for the current step should be disabled
    const isSaveDisabledForCurrentStep = () => {
        if (activeStep === 0 && fabStatus === 'complete') {
            return true;
        }
        if (activeStep === 1 && elecStatus === 'complete') {
            return true;
        }
        return false;
    };

    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden' }}>
            {id ? (
                <Header
                    title="UPDATE ASSIGN INSTALLER"
                    subtitle="Update Your Assign Installer Detail"
                />
            ) : (
                <Header
                    title="ADD ASSIGN INSTALLER"
                    subtitle="Manage Your Assign Installer Detail"
                />
            )}
            <form onSubmit={formik.handleSubmit}>
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    {isSmallScreen ? (
                        <>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(0, 2).map((label, index) => ( // Adjust slice for 2 steps
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (
                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 1}
                                                onClick={() => handleStep(index)}
                                                error={touchedSteps[index] && stepsWithErrors[index]}
                                            />
                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </>
                    ) : (
                        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={(props) => (
                                        <ColorlibStepIcon
                                            {...props}
                                            theme={theme}
                                            icon={index + 1}
                                            onClick={() => handleStep(index)}
                                            error={touchedSteps[index] && stepsWithErrors[index]}
                                        />
                                    )}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    )}

                    {activeStep === 0 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="date"
                                        label="Date:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.FabricatorDate}
                                        name="FabricatorDate"
                                        error={!!touched.FabricatorDate && !!errors.FabricatorDate}
                                        helperText={touched.FabricatorDate && errors.FabricatorDate}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                        disabled={fabStatus === 'complete'} // Disable input if complete
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ mx: 1, mt: 1, minWidth: 120 }}>
                                    <InputLabel id="Fabricator-label">Select Fabricator:</InputLabel>
                                    <Select
                                        labelId="Fabricator-label"
                                        id="Fabricator"
                                        name="Fabricator"
                                        value={values.Fabricator}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.Fabricator && Boolean(errors.Fabricator)}
                                        sx={{
                                            gridColumn: "span 2",
                                            color: theme.palette.text.primary
                                        }}
                                        disabled={fabStatus === 'complete'} // Disable input if complete
                                    >
                                        {Fabricatorusers.map((user) => (
                                            <MenuItem key={user._id} value={user._id}>
                                                {user.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {touched.Fabricator && errors.Fabricator && (
                                        <FormHelperText error>{errors.Fabricator}</FormHelperText>
                                    )}
                                </FormControl>
                            </Box>
                        </>
                    )}
                    {activeStep === 1 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="date"
                                        label="Date:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.ElectricianDate}
                                        name="ElectricianDate"
                                        error={!!touched.ElectricianDate && !!errors.ElectricianDate}
                                        helperText={touched.ElectricianDate && errors.ElectricianDate}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                        disabled={elecStatus === 'complete'} // Disable input if complete
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ mx: 1, mt: 1, minWidth: 120 }}>
                                    <InputLabel id="Electrician-label">Select Electrician:</InputLabel>
                                    <Select
                                        labelId="Electrician-label"
                                        id="Electrician"
                                        name="Electrician"
                                        value={values.Electrician}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.Electrician && Boolean(errors.Electrician)}
                                        sx={{
                                            gridColumn: "span 2",
                                            color: theme.palette.text.primary
                                        }}
                                        disabled={elecStatus === 'complete'} // Disable input if complete
                                    >
                                        {Electricianusers.map((user) => (
                                            <MenuItem key={user._id} value={user._id}>
                                                {user.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {touched.Electrician && errors.Electrician && (
                                        <FormHelperText error>{errors.Electrician}</FormHelperText>
                                    )}
                                </FormControl>
                            </Box>
                        </>
                    )}
                   
                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                            {activeStep < steps.length - 1 && ( // Show Next button until the last step
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleNext}
                                    // disabled={isSaveDisabledForCurrentStep()} // Disable next if current section is complete
                                >
                                    Next
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={formik.handleSubmit} // Call formik's handleSubmit
                                disabled={isSaveDisabledForCurrentStep()} // Disable Save/Update if current section is complete
                            >
                                {id ? 'Update' : 'Save'}
                            </Button>
                        </Stack>
                    </FormControl>
                </Stack>
            </form>
        </Box>
    );
}

export default AddAssignInstaller;
